import { get, post } from '../../utils/axios'

export const listIncomePaymentTypeAPI = async (body) => {
  return await get('payment/list/type', body)
}
export const listIncomePaymentAPI = async (body) => {
  return await get('payment/list', body)
}
export const listIncomeAPI = async (body) => {
  return await get('payment', body)
}

export const createIncomeAPI = async (body) => {
  return await post('payment', body)
}

export const updateIncomeAPI = async (body) => {
  return await post('payment/update', body)
}

export const deleteIncomeAPI = async (body) => {
  return await post('payment/delete', body)
}
